/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_HolidayInputs */

const en_reference_dataset_holiday = /** @type {(inputs: Reference_Dataset_HolidayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Holidays`)
};

/**
* | output |
* | --- |
* | "Holidays" |
*
* @param {Reference_Dataset_HolidayInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_holiday = /** @type {((inputs?: Reference_Dataset_HolidayInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_HolidayInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_holiday(inputs)
});